import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import LoadingIndicator from 'components/UI/LoadingIndicator';
import { FontWeight } from 'lib/styles';
import React from 'react';
import styled from 'styled-components';
import { Background, Border, Text } from 'styles/themeColors';
import { currencySign } from 'utils/formatters';

const TableFooterColumn = styled.span<any>`
  width: 200px;
  height: 20px;
  font-style: normal;
  font-weight: ${FontWeight.bold};
  color: ${Text.primary};
  font-size: 16px;
  line-height: 20px;
`;

const TableFooterData = styled.span<any>`
  width: 104px;
  height: 20px;
  text-align: right;
  color: ${Text.primary};
  font-size: 16px;
  line-height: 20px;
`;

const Surcharges = styled.span<any>`
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${Text.primary};
`;

interface OrderSummaryProps {
    country: string | null;
    subTotal: number;
    totalSurcharges?: number;
    totalDeliveryCost?: number;
    totalTax?: number;
    totalPriceWithTax?: number;
    isPriceUpdating?: boolean;
    totalDiscounts?: number;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
    country,
    subTotal,
    totalSurcharges,
    totalDeliveryCost,
    totalTax,
    totalPriceWithTax,
    isPriceUpdating,
    totalDiscounts
}) => {
    return (
        <FlexboxContainerComponent flexDirection="column" alignItems="flex-end" width="100%" padding="16px">
            <FlexboxContainerComponent padding="16px">
                <TableFooterColumn>Subtotal</TableFooterColumn>
                <TableFooterData>
                    {isPriceUpdating ? (
                        <LoadingIndicator size={25} margin="0 0 0 40px" center />
                    ) : (
                        subTotal && currencySign(country, subTotal)
                    )}
                </TableFooterData>
            </FlexboxContainerComponent>
            {totalDiscounts && totalDiscounts > 0 ? (
                <FlexboxContainerComponent padding="16px">
                    <Surcharges>includes savings</Surcharges>
                    <TableFooterData>-{totalDiscounts && currencySign(country, totalDiscounts)}</TableFooterData>
                </FlexboxContainerComponent>
            ) : null}
            {totalSurcharges && totalSurcharges > 0 ? (
                <FlexboxContainerComponent padding="16px">
                    <Surcharges>includes surcharges</Surcharges>
                    <TableFooterData>+{totalSurcharges && currencySign(country, totalSurcharges)}</TableFooterData>
                </FlexboxContainerComponent>
            ) : null}
            {totalDeliveryCost ? (
                <FlexboxContainerComponent
                    padding="16px"
                    borderTop={`1px solid ${Border.light}`}
                    borderBottom={`1px solid ${Border.light}`}
                >
                    <TableFooterColumn fontSize="15px">Shipping</TableFooterColumn>
                    <TableFooterData fontSize="15px">
                        {totalDeliveryCost && currencySign(country, totalDeliveryCost)}
                    </TableFooterData>
                </FlexboxContainerComponent>
            ) : null}
            {totalTax ? (
                <FlexboxContainerComponent borderTop="1px solid #E1E6EB" padding="16px">
                    <TableFooterColumn>Tax</TableFooterColumn>
                    <TableFooterData>{totalTax && currencySign(country, totalTax)}</TableFooterData>
                </FlexboxContainerComponent>
            ) : null}
            <FlexboxContainerComponent borderTop={`2px solid ${Background.navy}`} padding="16px">
                <TableFooterColumn>Order total</TableFooterColumn>
                <TableFooterData>

                    {isPriceUpdating ? <LoadingIndicator size={25} margin="0 0 0 40px" center />
                        : totalPriceWithTax
                            ? currencySign(country, totalPriceWithTax)
                            : currencySign(country, subTotal)}
                </TableFooterData>
            </FlexboxContainerComponent>
        </FlexboxContainerComponent>
    );
};

export default OrderSummary;